import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { AlertCircle } from 'lucide-react';
export const StickyBar: React.FC = () => {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white shadow-md" data-id="element-308">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center sm:space-x-6 space-y-2 sm:space-y-0" data-id="element-309">
        <div className="flex items-center space-x-2" data-id="element-310">
          <AlertCircle className="w-5 h-5 animate-pulse-fast" data-id="element-311" />
          <span className="font-bold text-sm sm:text-base uppercase tracking-wide" data-id="element-312">
            Esta oferta termina pronto
          </span>
        </div>
        <CountdownTimer size="sm" theme="dark" data-id="element-313" />
      </div>
    </div>;
};